export enum OperationType {
    CREATE = "CREATE",
    UPDATE = "UPDATE",
    DELETE = "DELETE"
}

export const getOperationTypeFromValue = (value: string): OperationType => {
    switch (value.toUpperCase()) {
        case "CREATE": {
            return OperationType.CREATE;
        }
        case "UPDATE": {
            return OperationType.UPDATE;
        }
        case "DELETE": {
            return OperationType.DELETE;
        }
        default: {
            return OperationType.CREATE;
        }
    }
};

export const getLabelFromOperationType = (operationType: OperationType): string =>{
    switch (operationType) {
        case OperationType.CREATE: {
            return "登録";
        }
        case OperationType.UPDATE: {
            return "編集";
        }
        case OperationType.DELETE: {
            return "削除";
        }
        default: {
            return "登録";
        }
    }
};
